/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.report.defs'

type $nsid = typeof $nsid

export { $nsid }

type ReasonType =
  | 'tools.ozone.report.defs#reasonAppeal'
  | 'tools.ozone.report.defs#reasonOther'
  | 'tools.ozone.report.defs#reasonViolenceAnimal'
  | 'tools.ozone.report.defs#reasonViolenceThreats'
  | 'tools.ozone.report.defs#reasonViolenceGraphicContent'
  | 'tools.ozone.report.defs#reasonViolenceGlorification'
  | 'tools.ozone.report.defs#reasonViolenceExtremistContent'
  | 'tools.ozone.report.defs#reasonViolenceTrafficking'
  | 'tools.ozone.report.defs#reasonViolenceOther'
  | 'tools.ozone.report.defs#reasonSexualAbuseContent'
  | 'tools.ozone.report.defs#reasonSexualNCII'
  | 'tools.ozone.report.defs#reasonSexualDeepfake'
  | 'tools.ozone.report.defs#reasonSexualAnimal'
  | 'tools.ozone.report.defs#reasonSexualUnlabeled'
  | 'tools.ozone.report.defs#reasonSexualOther'
  | 'tools.ozone.report.defs#reasonChildSafetyCSAM'
  | 'tools.ozone.report.defs#reasonChildSafetyGroom'
  | 'tools.ozone.report.defs#reasonChildSafetyPrivacy'
  | 'tools.ozone.report.defs#reasonChildSafetyHarassment'
  | 'tools.ozone.report.defs#reasonChildSafetyOther'
  | 'tools.ozone.report.defs#reasonHarassmentTroll'
  | 'tools.ozone.report.defs#reasonHarassmentTargeted'
  | 'tools.ozone.report.defs#reasonHarassmentHateSpeech'
  | 'tools.ozone.report.defs#reasonHarassmentDoxxing'
  | 'tools.ozone.report.defs#reasonHarassmentOther'
  | 'tools.ozone.report.defs#reasonMisleadingBot'
  | 'tools.ozone.report.defs#reasonMisleadingImpersonation'
  | 'tools.ozone.report.defs#reasonMisleadingSpam'
  | 'tools.ozone.report.defs#reasonMisleadingScam'
  | 'tools.ozone.report.defs#reasonMisleadingElections'
  | 'tools.ozone.report.defs#reasonMisleadingOther'
  | 'tools.ozone.report.defs#reasonRuleSiteSecurity'
  | 'tools.ozone.report.defs#reasonRuleProhibitedSales'
  | 'tools.ozone.report.defs#reasonRuleBanEvasion'
  | 'tools.ozone.report.defs#reasonRuleOther'
  | 'tools.ozone.report.defs#reasonSelfHarmContent'
  | 'tools.ozone.report.defs#reasonSelfHarmED'
  | 'tools.ozone.report.defs#reasonSelfHarmStunts'
  | 'tools.ozone.report.defs#reasonSelfHarmSubstances'
  | 'tools.ozone.report.defs#reasonSelfHarmOther'
  | l.UnknownString

export type { ReasonType }

const reasonType = /*#__PURE__*/ l.string<{
  knownValues: [
    'tools.ozone.report.defs#reasonAppeal',
    'tools.ozone.report.defs#reasonOther',
    'tools.ozone.report.defs#reasonViolenceAnimal',
    'tools.ozone.report.defs#reasonViolenceThreats',
    'tools.ozone.report.defs#reasonViolenceGraphicContent',
    'tools.ozone.report.defs#reasonViolenceGlorification',
    'tools.ozone.report.defs#reasonViolenceExtremistContent',
    'tools.ozone.report.defs#reasonViolenceTrafficking',
    'tools.ozone.report.defs#reasonViolenceOther',
    'tools.ozone.report.defs#reasonSexualAbuseContent',
    'tools.ozone.report.defs#reasonSexualNCII',
    'tools.ozone.report.defs#reasonSexualDeepfake',
    'tools.ozone.report.defs#reasonSexualAnimal',
    'tools.ozone.report.defs#reasonSexualUnlabeled',
    'tools.ozone.report.defs#reasonSexualOther',
    'tools.ozone.report.defs#reasonChildSafetyCSAM',
    'tools.ozone.report.defs#reasonChildSafetyGroom',
    'tools.ozone.report.defs#reasonChildSafetyPrivacy',
    'tools.ozone.report.defs#reasonChildSafetyHarassment',
    'tools.ozone.report.defs#reasonChildSafetyOther',
    'tools.ozone.report.defs#reasonHarassmentTroll',
    'tools.ozone.report.defs#reasonHarassmentTargeted',
    'tools.ozone.report.defs#reasonHarassmentHateSpeech',
    'tools.ozone.report.defs#reasonHarassmentDoxxing',
    'tools.ozone.report.defs#reasonHarassmentOther',
    'tools.ozone.report.defs#reasonMisleadingBot',
    'tools.ozone.report.defs#reasonMisleadingImpersonation',
    'tools.ozone.report.defs#reasonMisleadingSpam',
    'tools.ozone.report.defs#reasonMisleadingScam',
    'tools.ozone.report.defs#reasonMisleadingElections',
    'tools.ozone.report.defs#reasonMisleadingOther',
    'tools.ozone.report.defs#reasonRuleSiteSecurity',
    'tools.ozone.report.defs#reasonRuleProhibitedSales',
    'tools.ozone.report.defs#reasonRuleBanEvasion',
    'tools.ozone.report.defs#reasonRuleOther',
    'tools.ozone.report.defs#reasonSelfHarmContent',
    'tools.ozone.report.defs#reasonSelfHarmED',
    'tools.ozone.report.defs#reasonSelfHarmStunts',
    'tools.ozone.report.defs#reasonSelfHarmSubstances',
    'tools.ozone.report.defs#reasonSelfHarmOther',
  ]
}>()

export { reasonType }

/** An issue not included in these options */
type ReasonOther = 'tools.ozone.report.defs#reasonOther'

export type { ReasonOther }

/** An issue not included in these options */
const reasonOther = /*#__PURE__*/ l.token($nsid, 'reasonOther')

export { reasonOther }

/** Appeal a previously taken moderation action */
type ReasonAppeal = 'tools.ozone.report.defs#reasonAppeal'

export type { ReasonAppeal }

/** Appeal a previously taken moderation action */
const reasonAppeal = /*#__PURE__*/ l.token($nsid, 'reasonAppeal')

export { reasonAppeal }

/** Other */
type ReasonRuleOther = 'tools.ozone.report.defs#reasonRuleOther'

export type { ReasonRuleOther }

/** Other */
const reasonRuleOther = /*#__PURE__*/ l.token($nsid, 'reasonRuleOther')

export { reasonRuleOther }

/** Eating disorders */
type ReasonSelfHarmED = 'tools.ozone.report.defs#reasonSelfHarmED'

export type { ReasonSelfHarmED as ReasonSelfHarmEd }

/** Eating disorders */
const reasonSelfHarmED = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmED')

export { reasonSelfHarmED }

/** Non-consensual intimate imagery */
type ReasonSexualNCII = 'tools.ozone.report.defs#reasonSexualNCII'

export type { ReasonSexualNCII as ReasonSexualNcii }

/** Non-consensual intimate imagery */
const reasonSexualNCII = /*#__PURE__*/ l.token($nsid, 'reasonSexualNCII')

export { reasonSexualNCII }

/** Other sexual violence content */
type ReasonSexualOther = 'tools.ozone.report.defs#reasonSexualOther'

export type { ReasonSexualOther }

/** Other sexual violence content */
const reasonSexualOther = /*#__PURE__*/ l.token($nsid, 'reasonSexualOther')

export { reasonSexualOther }

/** Animal sexual abuse */
type ReasonSexualAnimal = 'tools.ozone.report.defs#reasonSexualAnimal'

export type { ReasonSexualAnimal }

/** Animal sexual abuse */
const reasonSexualAnimal = /*#__PURE__*/ l.token($nsid, 'reasonSexualAnimal')

export { reasonSexualAnimal }

/** Fake account or bot */
type ReasonMisleadingBot = 'tools.ozone.report.defs#reasonMisleadingBot'

export type { ReasonMisleadingBot }

/** Fake account or bot */
const reasonMisleadingBot = /*#__PURE__*/ l.token($nsid, 'reasonMisleadingBot')

export { reasonMisleadingBot }

/** Other dangerous content */
type ReasonSelfHarmOther = 'tools.ozone.report.defs#reasonSelfHarmOther'

export type { ReasonSelfHarmOther }

/** Other dangerous content */
const reasonSelfHarmOther = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmOther')

export { reasonSelfHarmOther }

/** Other violent content */
type ReasonViolenceOther = 'tools.ozone.report.defs#reasonViolenceOther'

export type { ReasonViolenceOther }

/** Other violent content */
const reasonViolenceOther = /*#__PURE__*/ l.token($nsid, 'reasonViolenceOther')

export { reasonViolenceOther }

/** Scam */
type ReasonMisleadingScam = 'tools.ozone.report.defs#reasonMisleadingScam'

export type { ReasonMisleadingScam }

/** Scam */
const reasonMisleadingScam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingScam',
)

export { reasonMisleadingScam }

/** Spam */
type ReasonMisleadingSpam = 'tools.ozone.report.defs#reasonMisleadingSpam'

export type { ReasonMisleadingSpam }

/** Spam */
const reasonMisleadingSpam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingSpam',
)

export { reasonMisleadingSpam }

/** Banned user returning */
type ReasonRuleBanEvasion = 'tools.ozone.report.defs#reasonRuleBanEvasion'

export type { ReasonRuleBanEvasion }

/** Banned user returning */
const reasonRuleBanEvasion = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleBanEvasion',
)

export { reasonRuleBanEvasion }

/** Dangerous challenges or activities */
type ReasonSelfHarmStunts = 'tools.ozone.report.defs#reasonSelfHarmStunts'

export type { ReasonSelfHarmStunts }

/** Dangerous challenges or activities */
const reasonSelfHarmStunts = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmStunts',
)

export { reasonSelfHarmStunts }

/** Deepfake adult content */
type ReasonSexualDeepfake = 'tools.ozone.report.defs#reasonSexualDeepfake'

export type { ReasonSexualDeepfake }

/** Deepfake adult content */
const reasonSexualDeepfake = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualDeepfake',
)

export { reasonSexualDeepfake }

/** Animal welfare violations */
type ReasonViolenceAnimal = 'tools.ozone.report.defs#reasonViolenceAnimal'

export type { ReasonViolenceAnimal }

/** Animal welfare violations */
const reasonViolenceAnimal = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceAnimal',
)

export { reasonViolenceAnimal }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyCSAM = 'tools.ozone.report.defs#reasonChildSafetyCSAM'

export type { ReasonChildSafetyCSAM as ReasonChildSafetyCsam }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyCSAM = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyCSAM',
)

export { reasonChildSafetyCSAM }

/** Other harassing or hateful content */
type ReasonHarassmentOther = 'tools.ozone.report.defs#reasonHarassmentOther'

export type { ReasonHarassmentOther }

/** Other harassing or hateful content */
const reasonHarassmentOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentOther',
)

export { reasonHarassmentOther }

/** Trolling */
type ReasonHarassmentTroll = 'tools.ozone.report.defs#reasonHarassmentTroll'

export type { ReasonHarassmentTroll }

/** Trolling */
const reasonHarassmentTroll = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTroll',
)

export { reasonHarassmentTroll }

/** Other misleading content */
type ReasonMisleadingOther = 'tools.ozone.report.defs#reasonMisleadingOther'

export type { ReasonMisleadingOther }

/** Other misleading content */
const reasonMisleadingOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingOther',
)

export { reasonMisleadingOther }

/** Content promoting or depicting self-harm */
type ReasonSelfHarmContent = 'tools.ozone.report.defs#reasonSelfHarmContent'

export type { ReasonSelfHarmContent }

/** Content promoting or depicting self-harm */
const reasonSelfHarmContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmContent',
)

export { reasonSelfHarmContent }

/** Unlabelled adult content */
type ReasonSexualUnlabeled = 'tools.ozone.report.defs#reasonSexualUnlabeled'

export type { ReasonSexualUnlabeled }

/** Unlabelled adult content */
const reasonSexualUnlabeled = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualUnlabeled',
)

export { reasonSexualUnlabeled }

/** Threats or incitement */
type ReasonViolenceThreats = 'tools.ozone.report.defs#reasonViolenceThreats'

export type { ReasonViolenceThreats }

/** Threats or incitement */
const reasonViolenceThreats = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceThreats',
)

export { reasonViolenceThreats }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyGroom = 'tools.ozone.report.defs#reasonChildSafetyGroom'

export type { ReasonChildSafetyGroom }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyGroom = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyGroom',
)

export { reasonChildSafetyGroom }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyOther = 'tools.ozone.report.defs#reasonChildSafetyOther'

export type { ReasonChildSafetyOther }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyOther',
)

export { reasonChildSafetyOther }

/** Hacking or system attacks */
type ReasonRuleSiteSecurity = 'tools.ozone.report.defs#reasonRuleSiteSecurity'

export type { ReasonRuleSiteSecurity }

/** Hacking or system attacks */
const reasonRuleSiteSecurity = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleSiteSecurity',
)

export { reasonRuleSiteSecurity }

/** Doxxing */
type ReasonHarassmentDoxxing = 'tools.ozone.report.defs#reasonHarassmentDoxxing'

export type { ReasonHarassmentDoxxing }

/** Doxxing */
const reasonHarassmentDoxxing = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentDoxxing',
)

export { reasonHarassmentDoxxing }

/** Privacy violation involving a minor */
type ReasonChildSafetyPrivacy =
  'tools.ozone.report.defs#reasonChildSafetyPrivacy'

export type { ReasonChildSafetyPrivacy }

/** Privacy violation involving a minor */
const reasonChildSafetyPrivacy = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyPrivacy',
)

export { reasonChildSafetyPrivacy }

/** Targeted harassment */
type ReasonHarassmentTargeted =
  'tools.ozone.report.defs#reasonHarassmentTargeted'

export type { ReasonHarassmentTargeted }

/** Targeted harassment */
const reasonHarassmentTargeted = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTargeted',
)

export { reasonHarassmentTargeted }

/** Dangerous substances or drug abuse */
type ReasonSelfHarmSubstances =
  'tools.ozone.report.defs#reasonSelfHarmSubstances'

export type { ReasonSelfHarmSubstances }

/** Dangerous substances or drug abuse */
const reasonSelfHarmSubstances = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmSubstances',
)

export { reasonSelfHarmSubstances }

/** Adult sexual abuse content */
type ReasonSexualAbuseContent =
  'tools.ozone.report.defs#reasonSexualAbuseContent'

export type { ReasonSexualAbuseContent }

/** Adult sexual abuse content */
const reasonSexualAbuseContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualAbuseContent',
)

export { reasonSexualAbuseContent }

/** False information about elections */
type ReasonMisleadingElections =
  'tools.ozone.report.defs#reasonMisleadingElections'

export type { ReasonMisleadingElections }

/** False information about elections */
const reasonMisleadingElections = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingElections',
)

export { reasonMisleadingElections }

/** Promoting or selling prohibited items or services */
type ReasonRuleProhibitedSales =
  'tools.ozone.report.defs#reasonRuleProhibitedSales'

export type { ReasonRuleProhibitedSales }

/** Promoting or selling prohibited items or services */
const reasonRuleProhibitedSales = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleProhibitedSales',
)

export { reasonRuleProhibitedSales }

/** Human trafficking */
type ReasonViolenceTrafficking =
  'tools.ozone.report.defs#reasonViolenceTrafficking'

export type { ReasonViolenceTrafficking }

/** Human trafficking */
const reasonViolenceTrafficking = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceTrafficking',
)

export { reasonViolenceTrafficking }

/** Hate speech */
type ReasonHarassmentHateSpeech =
  'tools.ozone.report.defs#reasonHarassmentHateSpeech'

export type { ReasonHarassmentHateSpeech }

/** Hate speech */
const reasonHarassmentHateSpeech = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentHateSpeech',
)

export { reasonHarassmentHateSpeech }

/** Harassment or bullying of minors */
type ReasonChildSafetyHarassment =
  'tools.ozone.report.defs#reasonChildSafetyHarassment'

export type { ReasonChildSafetyHarassment }

/** Harassment or bullying of minors */
const reasonChildSafetyHarassment = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyHarassment',
)

export { reasonChildSafetyHarassment }

/** Glorification of violence */
type ReasonViolenceGlorification =
  'tools.ozone.report.defs#reasonViolenceGlorification'

export type { ReasonViolenceGlorification }

/** Glorification of violence */
const reasonViolenceGlorification = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGlorification',
)

export { reasonViolenceGlorification }

/** Graphic violent content */
type ReasonViolenceGraphicContent =
  'tools.ozone.report.defs#reasonViolenceGraphicContent'

export type { ReasonViolenceGraphicContent }

/** Graphic violent content */
const reasonViolenceGraphicContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGraphicContent',
)

export { reasonViolenceGraphicContent }

/** Impersonation */
type ReasonMisleadingImpersonation =
  'tools.ozone.report.defs#reasonMisleadingImpersonation'

export type { ReasonMisleadingImpersonation }

/** Impersonation */
const reasonMisleadingImpersonation = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingImpersonation',
)

export { reasonMisleadingImpersonation }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonViolenceExtremistContent =
  'tools.ozone.report.defs#reasonViolenceExtremistContent'

export type { ReasonViolenceExtremistContent }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonViolenceExtremistContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceExtremistContent',
)

export { reasonViolenceExtremistContent }
